import * as actions from './FAT.actions'

const initialState = {
  loading: false,
  error: null,
  done: false,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FAT_ATTEMPTED:
      return {
        ...initialState,
        loading: true,
      }
    case actions.FAT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        done: true,
      }
    case actions.CLEAR_FAT_ERROR:
      return {
        ...initialState,
      }
    case actions.FAT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
        done: true,
      }
    default:
      return state
  }
}
